module.exports = __webpack_public_path__ + "static/img/wechatnew1.70d8831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechatnew1.png
// module id = vVMz
// module chunks = 1